/**
 * @file Utility: Badge System
 * @description Calculates commendation badges and case pins based on completion time
 *
 * Uses Total Completion Time (T) for badge tier and star rating calculations
 * per BriefScoringSystemV2 spec
 */

import { DEFAULT_TIME_TARGETS } from '../constants/ipScoringConfig';
import {
  calculateCasePins,
  calculateCommendationBadge,
} from './ipScoringSystem';

/**
 * Get all badge info at once based on completion time
 * @param totalCompletionTimeSec Total time from first to last find (seconds)
 * @param parTime Optional par time override (seconds)
 * @param aceTime Optional ace time override (seconds)
 * @returns Object with tier, name, percentile, and star rating
 */
export function getBadgeInfo(
  totalCompletionTimeSec: number,
  parTime: number = DEFAULT_TIME_TARGETS.parTime,
  aceTime: number = DEFAULT_TIME_TARGETS.aceTime,
): {
  tier: number;
  name: string;
  percentile: number;
  starRating: number;
} {
  const badgeInfo = calculateCommendationBadge(totalCompletionTimeSec);
  const starRating = calculateCasePins(
    totalCompletionTimeSec,
    parTime,
    aceTime,
  );

  return {
    tier: badgeInfo.tier,
    name: badgeInfo.name,
    percentile: badgeInfo.percentile,
    starRating,
  };
}
